var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"world-background"},[_c('cards-roulette',{attrs:{"options":_vm.options,"type":'program_currency_types'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }